/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */
const RADAR_TIMESERIES_WORKFLOW_AREA = {
    type: "FeatureCollection",
    features: [
        {
            type: "Feature",
            properties: {
                areaName: "Area 1",
            },
            geometry: {
                type: "Polygon",
                coordinates: [
                    [
                        [21.6925048828125, -20.164254834336596],
                        [23.9666748046875, -20.164254834336596],
                        [23.9666748046875, -18.22674258246203],
                        [21.6925048828125, -18.22674258246203],
                        [21.6925048828125, -20.164254834336596],
                    ],
                ],
            },
        },
    ],
};

export default RADAR_TIMESERIES_WORKFLOW_AREA;
